export default __webpack_public_path__ + "static/media/mail-to.2560756c.png";